import React from 'react';
import { Badge } from 'primereact/badge';
import { Avatar } from 'primereact/avatar';
import { Menu } from 'primereact/menu';
import { List, SignOut, UserCircle, Gear, Bell, EnvelopeSimple } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";

export default function MyToolBar({ user, onToggled, onLogout, appName, logo }) {
    let menuRight = React.useRef(null);
    const navigate = useNavigate();

    const items = [
        {
            label: user?.first_name
        },
        {
            label: "Profile",
            icon: <UserCircle fontSize={"1.5em"} />,
            command: () => {
                navigate("/profile/")
            }
        },
        {
            label: "Settings",
            icon: <Gear fontSize={"1.5em"} />,
            command: () => {
                navigate("/settings/")
            }
        },
        {
            label: "Logout",
            icon: <SignOut fontSize={"1.5em"} />,
            command: () => {
                if (onLogout) onLogout()
            }
        },
    ];

    return (
        <div className="d-flex align-items-center ps-toolbar w-100 py-3">
            <div>
                <List size={24} style={{ cursor: 'pointer' }} onClick={() => onToggled()} />
            </div>
            <div className="px-2 d-flex align-items-center">
                <img src={logo} alt="logo" />
                <div className="text-left" style={{ minWidth: 180 }}> {appName} </div>
            </div>
            <div className="w-100 d-flex justify-content-end px-2 gap-3">
                <div className="position-relative" style={{ cursor: 'pointer' }}>
                    <Bell style={{ fontSize: '1.5rem' }} />
                    <Badge value="2" severity="danger" style={{ position: 'absolute', top: -5, right: -10 }} />
                </div>
                <div className="position-relative" style={{ cursor: 'pointer' }}>
                    <EnvelopeSimple style={{ fontSize: '1.5rem' }} />
                    <Badge severity="danger" style={{ position: 'absolute', top: -5, right: -10 }} />
                </div>
            </div>
            <div>
                <Menu model={items} popup ref={menuRight} popupAlignment="right" />
                <Avatar 
                    label={user?.first_name?.slice(0, 2)?.toUpperCase()}
                    size="small" 
                    shape="circle" 
                    image={user?.avatar}
                    onClick={(event) => menuRight.current.toggle(event)}
                    style={{ cursor: 'pointer' }}
                />
            </div>
        </div>
    )
}
